import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/feature/Reveal";
import { chainStages } from "@/mocks/home";

export default function IndustryChainSection() {
  return (
    <section id="chain" className="w-full bg-secondary-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24 lg:px-10">
        <Reveal>
          <SectionHeading
            index="03"
            eyebrow="Chain Map"
            title="黑产图谱 · 一条链拆成三段看"
            description="把黑色产业链拆成上、中、下游，你会发现每一段的角色、利润与风险都完全不同。"
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-secondary-200 bg-secondary-200 md:grid-cols-3">
          {chainStages.map((stage, index) => (
            <Reveal key={stage.stage} delay={index * 80}>
              <div className="flex h-full flex-col bg-background-50 p-6 md:p-8">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 font-heading text-lg text-accent-800">
                    {stage.stage}
                  </span>
                  <span className="font-heading text-4xl text-background-300">
                    0{index + 1}
                  </span>
                </div>
                <h3 className="mt-6 font-heading text-xl text-foreground-950">
                  {stage.title}
                </h3>
                <p className="mt-3 text-sm leading-7 text-foreground-600">
                  {stage.desc}
                </p>
                <ul className="mt-6 space-y-3 border-t border-background-200 pt-6">
                  {stage.items.map((entry) => (
                    <li key={entry} className="flex items-center gap-3 text-sm text-foreground-700">
                      <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
                      {entry}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <p className="mt-8 text-sm leading-7 text-foreground-500">
            图谱只描述黑产的结构与分工，不提供任何交易渠道、联系方式或工具获取方式。看懂链条，是为了在它找上你之前先认出它。
          </p>
        </Reveal>
      </div>
    </section>
  );
}